import { TenderOfferParticipant } from 'types';
import { tenderParticipantStatusTypes } from 'utils/tenderOfferTypes';

type GetSoldAmount = {
  participant?: TenderOfferParticipant;
  sharePrice: number;
};

export const getSoldAmount = ({
  participant,
  sharePrice,
}: GetSoldAmount): number => {
  if (!participant) return 0;

  if (participant.status === tenderParticipantStatusTypes.ACCEPTED.value) {
    return participant.totalAccepted * sharePrice;
  }

  return 0;
};
